import paredAnalytics from 'pared/analytics/utils/ParedAnalytics'

export const track = {
  async categoryClicked(category: string) {
    await paredAnalytics.track(`Exray category clicked: ${category}`)
  },
}
